import { fetcher } from "../api/fetcher";
import { roomState } from "../states/room";

export async function adminKickUserInRoom(userId: string) {
  fetcher
    .post({
      path: "/active-room/kick",
      payload: {
        user_id: userId,
        room_id: roomState.id,
      },
    })
    .catch(() => {
    });
}
